/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:30:48
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open Carlcare",
    name2: "Reservation now",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "Enjoy Carlcare Battery Replacement Service !", // 标题
    name10: "Enjoy an original battery replacement service for designated Infinix/Tecno/itel models, now available at Up to 50% off!",
    name11: "- Battery prices vary by model. Please check the updated price list below for more details.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Battery Replacement ?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name18: "3-Month Warranty",
    name19: "Get a 3-month official warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Get a great discount on battery prices.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name28: "4. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare Hotline at: 07080632363.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Service Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "เลือกรุ่นของอุปกรณ์",
    name2: "คำอธิบายของปัญหา:",
    name3: "แตะเพื่อเลือกศูนย์บริการ",
    name4: "ศูนย์บริการ:",
    name5: "เวลาการจอง:",
    name6: "โปรดอธิบายปัญหาที่พบในอุปกรณ์อย่างละเอียด",
    name7: "แตะเพื่อเลือกเวลาที่จะเข้าถึง",
    name8: "โปรดป้อนรายละเอียดการติดต่อที่ถูกต้องที่สามารถติดต่อคุณได้",
    name9: "สามารถจองตามเวลาดังต่อไปนี้",
    name10: "กรุณาป้อนหมายเลขโทรศัพท์ของคุณ",
    name11: "ราคา",
    name12: "ข้อมูลส่วนบุคคล:",
    name13: "โปรดป้อนชื่อของคุณ",
    name14: "ส่ง",
    name15: "ยกเลิก",
    name16: "ตกลง",
  },
  shops: {
    name1: "อิงตามแบรนด์ที่คุณเลือกอิงตามแบรนด์ที่คุณเลือก มีศูนย์บริการต่อไปนี้พร้อมให้บริการคุณ!",
    name2: "เราจะเพิ่มร้านค้าปลีกมากขึ้นเร็วๆ นี้! คอยติดตามเรา!",
  },
  price: {
    name1: "แบรนด์",
    name2: "โมเดล",
    name3: "รายการ",
    name4: "ราคา",
    name5: "โปรดอย่าลืมว่า:",
    name6: "ราคานี้มีไว้เพื่อใช้อ้างอิงเท่านั้น และราคาที่แท้จริงจะขึ้นอยู่กับสภาพของอุปกรณ์ของคุณ",
    name7: "หากไม่มีสัญลักษณ์พิเศษ หน่วยของราคาเป็นไปตามสกุลเงินท้องถิ่น",
    name8: "เสียใจด้วย ไม่มีข้อมูลราคาสำหรับภูมิภาคนี้",
    name11:"ค่าแรง",
    name12:"ราคารวม",
    name13: "5. หากค่าแรงเป็น \"/\" หมายความว่าต้องปรึกษาเกี่ยวกับค่าแรงกับทางร้านค้า",
    item_main_board: "เมนบอร์ด",
    item_screen_frame: "หน้าจอ (กรอบ)",
    item_screen_screen_frame: "หน้าจอรอง (กรอบ)",
    item_touch_screen: "หน้าจอสัมผัส",
    item_camera: "กล้องถ่ายรูป",
    item_fixed_focus_camera: "กล้องโฟกัสคงที่",
    item_auto_focus_camera: "กล้องโฟกัสอัตโนมัติ",
    item_screen: "หน้าจอ",
    item_secondary_screen: "หน้าจอรอง",
    item_fingerprint_module: "โมดูลลายนิ้วมือ",
    item_speaker: "ลำโพง",
    item_receiver: "หูโทรศัพท์",
    item_small_board: "บอร์ดย่อย",
    item_battery_cover: "ฝาครอบแบตเตอรี่",
    item_battery: "แบตเตอรี่",
    item_charger: "ที่ชาร์จ",
    item_usb_cable: "สาย USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ไม่มีข้อมูล",
    name2: "ผู้ให้บริการ:",
    name3: "แบรนด์บริการ:",
    name4: "โทรศัพท์:",
    name5: "ปริมาณของคำสั่งซื้อ:",
    name6: "การจัดอันดับบริการ",
    name7: "สภาพแวดล้อมของการบริการ:",
    name8: "ทัศนคติการบริการ:",
    name9: "ประสิทธิภาพการให้บริการ:",
    name10: "คุณภาพของบริการ:",
    name11: "การประเมินลูกค้า",
    name12:"ถึง",
    name13:"ปิดแล้ว",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "เปิด Carlcare",
    name1: "โปรดบันทึกภาพหน้าจอข้อมูลการจองและบันทึกไว้ เพื่อใช้เป็นใบเสร็จรับเงินในการเข้าใช้บริการพิเศษ",
    name2: "ส่งสำเร็จแล้ว",
    name3: "1. ทำความสะอาดข้อมูล",
    name4: "โปรดสำรองข้อมูลส่วนตัวที่สำคัญในโทรศัพท์ล่วงหน้า",
    name5: "2. หยุดใช้งาน เปิดเครื่องด้วยรหัสผ่าน",
    name6: "ก่อนไปที่ร้านที่ให้บริการ โปรด",
    name7: "ศูนย์บริการ",
    name8: "เวลาการจอง",
    name9: "คำอธิบายของปัญหา",
    name10: "รุ่นอุปกรณ์",
    name11: "หมายเลขการสั่งซื้อ",
    name12: "ข้อมูลคำสั่งซื้อ",
  },
  title: {
    
    name1: "รองรับประเทศดังต่อไปนี้:",
    name2: "เลือกรุ่น",
    name3: "การจอง",
    name4: "รายละเอียดศูนย์บริการ",
    name5: "เลือกศูนย์บริการ",
  },
  error: {
    
    name1: "ไม่มีข้อมูล โปรดตรวจสอบข้อมูลการซ่อมแซมของคุณ",
    name2: "ต้องการความช่วยเหลือเพิ่มเติมใช่หรือไม่ โปรดติดต่อเรา",
    name3: "เสียใจด้วย ไม่พบศูนย์ Carlcare ในภูมิภาคนี้",
    name4: "โปรดเลือกศูนย์บริการก่อน",
    name5: "ล้มเหลว",
    name6: "โปรดเลือกรุ่นของอุปกรณ์ก่อน",
    name7: "รายละเอียด",
    name8: "โปรดอธิบายความต้องการของคุณอย่างละเอียด",
    name9: "",
  },
  add1:{
    "name0": "th-rTH",
    "name1": "คำสั่งซื้อของคุณได้รับการยืนยันแล้ว เราจะรอคอยการมาถึงของคุณ",
    "name2": "เลือกเมือง",
    "name3": "กรุณาใส่หมายเลขโทรศัพท์ %1$s หลัก",
    "name4": "เวลาทำการ",
    "name5": "วันจันทร์",
    "name6": "วันอังคาร",
    "name7": "วันพุธ",
    "name8": "วันพฤหัสบดี",
    "name9": "วันศุกร์",
    "name10": "วันเสาร์",
    "name11": "วันอาทิตย์",
    "name12": "ป้อนประเทศและค้นหา"
  },
  add2:{
    "name0": "Thai",
    "name1": "ขั้นตอนส่งเครื่องซ่อม",
    "name2": "เข้าไปซ่อมที่ศูนย์บริการ",
    "name3": "บริการ รับ-ส่ง เครื่องถึงที่",
    "name4": "อาการส่งซ่อม",
    "name5": "โปรดเลือกอาการส่งซ่อม",
    "name6": "เวลาเข้ารับ",
    "name7": "เลือกเวลาให้ขนส่งเข้ารับ",
    "name8": "สถานที่ให้ขนส่งเข้ารับ",
    "name9": "โปรดระบุที่อยู่ เลขที่ / ตำบล / อำเภอ / จังหวัด",
    "name10": "โปรดระบุรหัสไปรษณีย์",
    "name11": "เพิ่มที่อยู่จัดส่งเครื่องคืน",
    "name12": "ระบุที่อยู่สำหรับจัดส่งเครื่องคืน",
    "name13": "อื่น ๆ",
    "name14":"โปรดระบุอาการหรือปัญหาเครื่องให้ชัดเจน",
    "name15":"รหัสไปรษณีย์",
    "name16":"โปรดระบุที่อยู่จัดส่งคืน เลขที่ / ตำบล / อำเภอ / จังหวัด ให้เรียบร้อย",
    "name17":"โปรดระบุหมายเลขส่งคืน",
    "name18":"หมายเลขส่งคืน",
    "name19":"ที่อยู่จัดส่ง",
    "name20":"เลือกจังหวัด",
  },
  coupons: {
    name1:"Coupons",
    name2:"กดเพื่อเปลี่ยนเส้นทาง",
    name3:"เปิดแอปพลิเคชัน Carlcare เพื่อให้คะแนนออร์เดอร์",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"เลือกบริการ",
    name7:"ทำความสะอาดฟรี",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ข้อมูลไม่ถูกต้อง",
    "cancelReason1": "ไม่สามารถมาถึงได้ทันเวลา",
    "cancelReason2": "สั่งซื้อซ้ำ/ไม่ใช่คำสั่งซื้อของฉัน",
    "cancelReason3": "จะไม่เกิดความผิดพลาดขึ้นอีก",
    "cancelReason4": "เพื่อการทดสอบ/การสอบถาม/กิจกรรม/…เท่านั้น",
    "cancelReason5": "ราคาสูง",
    "cancelReason6": "ขาดแคลนวัสดุ",
    "cancelReason7": "ไม่มีบริการที่แตกต่าง",
    "cancelReason8": "ร้านค้าไกลเกินไป",
    "cancelReason9": "ร้านค้าปิด",
    "cancelReason10": "ทัศนคติในการให้บริการที่ไม่ดี",
    "cancelReason11": "เปลี่ยน/ซ่อมผลิตภัณฑ์ตราอื่น",
    "cancelReason12": "ไม่พบร้านนี้",
    "cancelReason13": "อื่นๆ",
    "cancelOrder": "ยกเลิกคำสั่งซื้อ",
    "reason_dialog_title": "โปรดบอกเราว่าเหตุใดจึงยกเลิก",
    "Cancel": "ยกเลิก",
    "OK": "ตกลง",
    "name1": "ป้อนรหัสยืนยัน",
    "name2": "รหัสการตรวจสอบไม่ถูกต้อง",
    "repair_reservation_detail_canceled": "คำสั่งนี้ถูกยกเลิกแล้ว!",
    "purchase_cancel_dialog_content": "คุณยืนยันที่จะยกเลิกคำสั่งซื้อนี้หรือไม่?",
    "yes": "ใช่",
    "no": "ไม่ใช่"
}
};
